"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var functions_1 = require("./functions");
var defaultValue_1 = require("../JSchema/defaultValue");
var validFunction_1 = require("../JSchema/validFunction");
var calcFunction_1 = require("../JSchema/calcFunction");
var aggregateFunction_1 = require("../JSchema/aggregateFunction");
var clearData_1 = require("../JSchema/clearData");
var getValidations_1 = require("../JSchema/getValidations");
var getRuleMessage_1 = require("../JSchema/getRuleMessage");
var setData_1 = require("../JSchema/setData");
var WrappedPropertyCtor_1 = require("./WrappedPropertyCtor");
var WrappedPropertyBase = /** @class */ (function () {
    function WrappedPropertyBase(dest, parent, propName, schema, options) {
        var _this = this;
        /**
         * pełny wynik validacji po $validate
         *
         * @type {(IValidateResult | null)}
         * @memberof IWrappedProperty
         */
        this.$validateResult = null;
        /**
         * pełny wynik sprawdzania ostrzeżeń
         *
         * @type {IValidateResult[]}
         * @memberof IWrappedProperty
         */
        this.$checkResult = [];
        this.$parent = dest;
        this._options = options;
        var internal = (this._internal = {
            vm: null,
            options: options,
            parent: parent,
            key: propName,
            schema: schema,
            computed: {},
            watch: {},
            calcargs: [],
            reactiveData: undefined,
            needsCalcArgs: false,
            useComputedModel: false,
            vmUserData: null,
            mparent: null
        });
        var self = this;
        // root
        if (dest) {
            this.$root = dest.$root;
        }
        else {
            this.$root = this;
        }
        // create schema
        var $schema = (this.$schema = {
            type: schema.type
        });
        (0, functions_1.wrapSchemaProps)(this.$schema, internal, 'string', ['title', 'shortTitle', 'description']);
        if (schema.format) {
            $schema.format = schema.format;
        }
        if (schema.default !== undefined) {
            $schema.default = schema.default;
        }
        // default value
        if (parent[propName] === undefined) {
            options.Vue.set(parent, propName, (0, defaultValue_1.default)(schema, true));
        }
        // wrap schema.emun
        if (schema.enum !== undefined) {
            if (self.$isArrayItem) {
                if (!Array.isArray(schema.enum)) {
                    (0, functions_1.wrapSchemaProp)(this.$schema, 'enum', internal, function (newValue) {
                        if (newValue) {
                            var mvalue = self.$model;
                            if (mvalue !== undefined && newValue.indexOf(mvalue) === -1) {
                                options.Vue.nextTick(function () {
                                    self.$removeRow();
                                });
                            }
                            /*
                            setTimeout(() => {
                              self.$removeRow();
                            });
                            */
                        }
                    });
                }
                else {
                    this.$schema.enum = schema.enum;
                    var mvalue = self.$model;
                    if (mvalue !== undefined && this.$schema.enum.indexOf(mvalue) === -1) {
                        options.Vue.nextTick(function () {
                            self.$removeRow();
                        });
                        /*
                        setTimeout(() => {
                          self.$removeRow();
                        }, 0);
                        */
                    }
                }
            }
            else {
                if (!Array.isArray(schema.enum)) {
                    (0, functions_1.wrapSchemaProp)(this.$schema, 'enum', internal);
                }
                else {
                    this.$schema.enum = schema.enum;
                }
            }
        }
        // wrap schema.required
        if (schema.required !== undefined &&
            schema.type !== 'object' &&
            (typeof schema.required === 'string' || typeof schema.required === 'boolean')) {
            schema.fieldRequired = schema.required;
        }
        (0, functions_1.wrapSchemaProps)(this.$schema, internal, 'boolean', ['fieldRequired', 'readOnly']);
        // wrap schema.disabled
        if (internal.schema.disabled !== undefined) {
            if (typeof internal.schema.disabled !== 'boolean') {
                var prevDirty_1 = false;
                (0, functions_1.wrapSchemaProp)(this.$schema, 'disabled', internal, function (newValue, oldValue) {
                    if (newValue) {
                        prevDirty_1 = _this.$dirty; // zapamiętanie czy pole było odwiedzane
                        if (prevDirty_1) {
                            _this.$dirty = false;
                        }
                        var defValue = void 0;
                        if (schema.type === 'array') {
                            // zeby pominąc length
                            // debugger;
                            if (schema.default) {
                                if (typeof schema.default === 'number') {
                                    defValue = [];
                                }
                                else {
                                    defValue = Array.from(schema.default);
                                }
                            }
                            else {
                                defValue = [];
                            }
                        }
                        else {
                            // defValue = defaultValue(schema, false);
                            defValue = (0, defaultValue_1.default)(schema, true);
                        }
                        if (defValue === undefined) {
                            // gdy nie ma domyslnej wartości usuń z modelu === undefined
                            // options.Vue.delete(parent, propName);
                            // jednak lepiej nie usuwać, bo traci się wszystkie połczenia dynamiczne z Vue
                            // this.$setData(undefined);
                            parent[propName] = undefined;
                        }
                        else {
                            // ustaw domyślną wartość
                            _this.$setData(defValue, undefined, true);
                        }
                        // zapamietanie w $root któ®e są wyłączone
                        options.disabledFields[_this.$path] = true;
                    }
                    else {
                        if (prevDirty_1) {
                            _this.$dirty = prevDirty_1; // przywrócenie informacji że pole było odwiedzone
                        }
                        // console.log('restore disabled', parent[propName]), defaultValue(schema, true);
                        var prevValue = parent[propName];
                        if (parent[propName] === undefined) {
                            // w przypadku gdy w polu jest indefined to ustawić domyslną wartośc
                            options.Vue.set(parent, propName, (0, defaultValue_1.default)(schema, true));
                            _this._internal.mparent = parent[propName];
                        }
                        else if (schema.type === 'array') {
                            if ($schema.length !== undefined) {
                                _this.$setLength($schema.length);
                            }
                            else if ((typeof schema.default === 'number') && (!prevValue || (prevValue.length === 0))) {
                                _this.$setLength(schema.default);
                            }
                        }
                        delete options.disabledFields[_this.$path];
                    }
                });
            }
            else {
                this.$schema.disabled = internal.schema.disabled;
                if (internal.schema.disabled) {
                    var defValue = void 0;
                    if (schema.type === 'array') {
                        // zeby pominąc length
                        // debugger;
                        if (schema.default) {
                            defValue = Array.from(schema.default);
                        }
                        else {
                            defValue = [];
                        }
                    }
                    else {
                        // defValue = defaultValue(schema, false);
                        defValue = (0, defaultValue_1.default)(schema, true);
                    }
                    if (defValue === undefined) {
                        parent[propName] = undefined;
                        // options.Vue.delete(parent, propName);
                    }
                    else {
                        this.$setData(defValue);
                    }
                }
            }
        }
        /*
        if (schema.fieldRequired !== undefined) {
          if (typeof schema.fieldRequired !== 'boolean') {
            wrapSchemaProp(this, 'fieldRequired', internal, 'boolean');
          } else {
            this.$schema.fieldRequired = schema.fieldRequired;
          }
        }
        */
        // tworzenie funkcji validującej
        if (!options.disableValidations && schema.validFunc) {
            internal.needsCalcArgs = true;
            var validFunc_1 = (0, validFunction_1.default)(schema, schema.validFunc, true, process.env.NODE_ENV === 'development' && schema.debug);
            internal.computed.validFunc = {
                get: function () {
                    var funcvalue = validFunc_1.apply(parent, internal.calcargs);
                    if (funcvalue === true || funcvalue === undefined) {
                        return null;
                    }
                    if (funcvalue === false) {
                        return 'validFunc';
                    }
                    return funcvalue;
                }
            };
            /*
            internal.watch.validFunc = {
              handler: (newValue: any, oldValue: any) => {
                if (self.$dirty) {
                  self.$validate();
                }
              },
              immediate: false
            };
            */
        }
        // warning
        if (schema.warnings) {
            this.$schema.warnings = {};
            (0, functions_1.wrapWarningProps)(this.$schema, internal, 'boolean', ['fieldRequired']);
            // format
            if (schema.warnings.format) {
                this.$schema.warnings.format = schema.warnings.format;
            }
            // enum
            if (schema.warnings.enum !== undefined) {
                if (!Array.isArray(schema.warnings.enum)) {
                    (0, functions_1.wrapWarningProp)(this.$schema, 'enum', internal);
                }
                else {
                    this.$schema.warnings.enum = schema.warnings.enum;
                }
            }
            if (!options.disableValidations && schema.warnings.validFunc) {
                internal.needsCalcArgs = true;
                var validFunc_2 = (0, validFunction_1.default)(schema, schema.warnings.validFunc, true, process.env.NODE_ENV === 'development' && schema.debug);
                internal.computed.warningValidFunc = {
                    get: function () {
                        var funcvalue = validFunc_2.apply(parent, internal.calcargs);
                        if (funcvalue === true || funcvalue === undefined) {
                            return null;
                        }
                        if (funcvalue === false) {
                            return 'validFunc';
                        }
                        return funcvalue;
                    }
                };
                /*
                internal.watch.validFunc = {
                  handler: (newValue: any, oldValue: any) => {
                    if (self.$dirty) {
                      self.$validate();
                    }
                  },
                  immediate: false
                };
                */
            }
        }
        if (!self._options.disableCalculations) {
            // tworzenie funkcji wyliczjącej wartośc na podstawie innych pól
            if (schema.calc) {
                internal.needsCalcArgs = true;
                var calcFunc_1 = (0, calcFunction_1.default)(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
                // wymuszenie zmiany po każdej zmianie zaleznych danych
                var calcCount_1 = 0;
                var res_1 = undefined;
                internal.computed.calc = {
                    get: function () {
                        calcCount_1++;
                        if (self.$disabled) {
                            res_1 = undefined;
                            return calcCount_1;
                        }
                        if (process.env.NODE_ENV === 'development') {
                            try {
                                res_1 = calcFunc_1.apply(parent, internal.calcargs);
                                if ((res_1 === undefined &&
                                    schema.calc.when === undefined &&
                                    schema.calc.indexOf('undefined') === -1) ||
                                    // tslint:disable-next-line: use-isnan
                                    res_1 === NaN) {
                                    console.error('[DEBUG] ERR calc result: ', self.$path, schema.calc, res_1);
                                }
                            }
                            catch (err) {
                                console.error('[DEBUG] ERR calc: ', self.$path, schema.calc, err);
                                // tslint:disable-next-line: no-debugger
                                debugger;
                                res_1 = undefined;
                            }
                        }
                        else {
                            try {
                                res_1 = calcFunc_1.apply(parent, internal.calcargs);
                            }
                            catch (_a) {
                                res_1 = undefined;
                            }
                        }
                        return calcCount_1;
                        // if (schema.calc ==='this.Dotacja + this.SrodkiWlasne + this.WkladOsobowy + this.WkladRzeczowy + 5')
                    }
                };
                internal.watch.calc = {
                    handler: function (calcCount) {
                        if (res_1 !== undefined) {
                            if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                                self.$dirty = true;
                            }
                            self.$setData(res_1, undefined, true);
                        }
                    },
                    immediate: true
                };
                // computed.calc = calcFunc;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.summary) {
                schema.aggregate = {
                    func: 'sum',
                    array: schema.summary.array,
                    property: schema.summary.property,
                    when: schema.summary.when,
                    if: schema.summary.if,
                    delay: schema.summary.delay
                };
                delete schema.summary;
            }
            // tworzenie funkcji sumującej wartość z tablicy
            if (schema.aggregate) {
                internal.needsCalcArgs = true;
                var aggregateFunc_1 = (0, aggregateFunction_1.default)(schema, true, process.env.NODE_ENV === 'development' && schema.debug);
                var calcCount_2 = 0;
                var res_2 = undefined;
                // if (schema.aggregate.async) {
                if (schema.aggregate.delay) {
                    // if (false) {
                    setTimeout(function () {
                        // console.log('delayed create aggregate',obj.$path);
                        var asyncVm = new internal.options.Vue({
                            computed: {
                                aggregate: {
                                    get: function () {
                                        // console.log('delayed run aggregate', obj.$path);
                                        if (process.env.NODE_ENV === 'development') {
                                            var res_3 = aggregateFunc_1.apply(parent, internal.calcargs);
                                            // tslint:disable-next-line: use-isnan
                                            if (res_3 === undefined || res_3 === NaN) {
                                                console.error('ERR aggregate:delay result=', res_3, propName, schema.calc);
                                            }
                                            return res_3;
                                        }
                                        else {
                                            return aggregateFunc_1.apply(parent, internal.calcargs);
                                        }
                                    }
                                }
                            },
                            watch: {
                                aggregate: function (newValue) {
                                    internal.options.Vue.set(parent, propName, newValue);
                                }
                            }
                        });
                        //  this.vueInstances.push(asyncVm);
                    }, schema.aggregate.delay);
                }
                else {
                    internal.computed.aggregate = {
                        get: function () {
                            calcCount_2++;
                            if (self.$disabled) {
                                res_2 = undefined;
                                return calcCount_2;
                            }
                            // console.log('run agg', self.internal);
                            if (process.env.NODE_ENV === 'development') {
                                try {
                                    res_2 = aggregateFunc_1.apply(parent, internal.calcargs);
                                    // tslint:disable-next-line: use-isnan
                                    if (res_2 === undefined || res_2 === NaN) {
                                        console.error('[DEBUG] ERR aggregate result: ', self.$path, schema.aggregate, res_2);
                                    }
                                }
                                catch (err) {
                                    console.error('[DEBUG] ERR aggregate: ', self.$path, schema.aggregate, err);
                                    // tslint:disable-next-line: no-debugger
                                    debugger;
                                    res_2 = undefined;
                                }
                            }
                            else {
                                try {
                                    res_2 = aggregateFunc_1.apply(parent, internal.calcargs);
                                }
                                catch (_a) {
                                    res_2 = undefined;
                                }
                            }
                            return calcCount_2;
                            // return aggregateFunc()
                        }
                    };
                    internal.watch.aggregate = {
                        handler: function (calcCount) {
                            // Vue.set(parent, propName, newValue);
                            if (res_2 !== undefined) {
                                if (!self.$dirty && (self._options.dirtyOnBlur || self._options.dirtyOnInput)) {
                                    self.$dirty = true;
                                }
                                self.$setData(res_2, undefined, true);
                            }
                        },
                        immediate: true
                    };
                }
            }
        }
    }
    Object.defineProperty(WrappedPropertyBase.prototype, "$key", {
        /**
         * nazwa pola, dla elementów tablicy jego indeks w tablicy
         *
         * @type {(string | number)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            this.$parent && this.$parent.$setLength && this.$parent.$model; // tylko dotknięcie jesli jest tablicą
            // this.$isArrayItem && this.$parent?.$model;
            return this._internal.key;
        },
        /**
        * nazwa pola, dla elementów tablicy jego indeks w tablicy
        *
        * @type {(string | number)}
        * @memberof WrappedPropertyBase
        */
        set: function (value) {
            this.$changeKey(value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$model", {
        /**
         * wartość prosto z modelu
         *
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this._internal.parent[this._internal.key];
        },
        /**
         * wartośc prosto z modelu
         *
         * @memberof WrappedPropertyBase
         */
        set: function (value) {
            if (this.$isArrayItem) {
                this._options.Vue.set(this._internal.parent, this._internal.key, value);
            }
            else {
                this._internal.parent[this._internal.key] = value;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$value", {
        /**
         * wartośc tekstowa dla pola prostego, w polach typu `array` czy `object`, to samo co w `$model`
         *
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (this._internal.useComputedModel) {
                return this._internal.vm.model;
            }
            else {
                return this.getValue();
            }
        },
        /**
         * wartośc tekstowa dla pola prostego, w polach typu `array` czy `object`, to samo co w `$model`
         *
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        set: function (newValue) {
            if (process.env.NODE_ENV === 'development') {
                // sprawdzam czy czasem nie ma calc lub aggreagate
                if (this._internal.schema.calc && !this._internal.schema.calc.when) {
                    throw new Error('ERR Próbujesz ustawić pole `' + this.$path + '` które jest wyliczane przez `calc`');
                }
                else if (this._internal.schema.aggregate) {
                    throw new Error('ERR Próbujesz ustawić pole `' + this.$path + '` które jest wyliczane przez `aggreagate`');
                }
            }
            this.setValue(newValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$form", {
        /**
         * dostęp do zmiennej `form` bazowego komponentu
         *
         * @readonly
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this._internal.options.form;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$data", {
        /**
         * obiekt danych użytkownika, można dodawać dowolne pola
         *
         * @readonly
         * @type {*}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (this._internal.vmUserData === null) {
                /*
                if (process.env.NODE_ENV === 'development') {
                  console.log('create $data');
                }
                */
                var userData = {};
                this._internal.vmUserData = this._options.Vue.observable({ userData: userData });
            }
            return this._internal.vmUserData.userData;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$error", {
        /**
         * komunikat błędu, lub null
         *
         * @readonly
         * @type {(string | null)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            // return this.$getUserData('error', null);
            if (!this.$disabled && this.$dirty) {
                return this.$validate();
            }
            else {
                return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$warnings", {
        /**
         * lista ostrzeżeń
         *
         * @readonly
         * @type {string[]}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (!this.$disabled && this.$dirty) {
                return this.$check();
            }
            else {
                return [];
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$dirty", {
        /**
         * czy element był "dotykany"
         *
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$getUserData('dirty', this._options.startDirty);
        },
        /**
         * czy element był "dotykany"
         *
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        set: function (newValue) {
            this.$setUserData('dirty', newValue);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$path", {
        /**
         * pełna ścieżka do pola
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            var result = '';
            if (this.$parent) {
                if (this.$parent.$schema.type === 'array') {
                    return this.$parent.$path + '[' + this.$key + ']';
                }
                var ppath = this.$parent.$path;
                if (ppath) {
                    return ppath + '.' + this.$key;
                }
                else {
                    return this.$key.toString();
                }
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$hasFocus", {
        /**
         * czy pole ma fokus
         *
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$getUserData('focused', false);
            // return this._internal.reactiveData.focused;
        },
        /**
         * czy pole ma fokus
         *
         * @memberof WrappedPropertyBase
         */
        set: function (newValue) {
            if (newValue) {
                this.$setUserData('focused', true);
                // this._internal.reactiveData.focused = true;
                if (this._internal.options.resetOnFocus) {
                    this.$reset();
                }
            }
            else {
                // if (vm.focused) {
                if (true) {
                    /*
             if (typeok) {
                 this.vm.stringValue = null;
             }
             */
                    // this._internal.reactiveData.focused = false;
                    this.$setUserData('focused', false);
                    // console.log('$hasFocus', this.$path, newValue, dirty, self.dirtyOnBlur);
                    if (!this.$disabled && !this.$dirty && this._options.dirtyOnBlur) {
                        // dirty = true;
                        // console.log('validate on blur', obj.$validate());
                        // this.$validate();
                        this.$dirty = true;
                    }
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$title", {
        /**
         * pobranie tytułu pola, `title` w schema
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$schema.title ? this.$schema.title : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$shortTitle", {
        /**
         * pobranie skróconego tytułu pola, `shortTitle` w schema
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$schema.shortTitle !== undefined ? this.$schema.shortTitle : this.$title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$description", {
        /**
         * pobranie opisu pola, `description` w schema
         *
         * @readonly
         * @type {string}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return this.$schema.description ? this.$schema.description : '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$enum", {
        /**
        * pobranie dopuszczalnych wartości pola, `enum` w schema
        * pusta tablica gdy brak definicji
        *
        * @readonly
        * @type {Array}
        * @memberof WrappedPropertyBase
        */
        get: function () {
            return this.$schema.enum || [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$disabled", {
        /**
         * czy element jest wyłączony, sprawdza również obiekty nadrzędne
         *
         * @readonly
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return (0, functions_1.anyDisabled)(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$enabled", {
        /**
         * odwrotnośc $disabled
         *
         * @readonly
         * @type {boolean}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            return !(0, functions_1.anyDisabled)(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$isArrayItem", {
        /**
         * czy to jest element tablicy ?
         *
         * @readonly
         * @memberof WrappedPropertyBase
         */
        get: function () {
            // return !!this.$parent && this.$parent.$schema.type === 'array';
            return this.$parent && (this.$parent.$setLength) && (typeof this._internal.key === 'number');
        },
        enumerable: false,
        configurable: true
    });
    /**
     * ustawienie $hasFocus na tru
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$focus = function () {
        this.$hasFocus = true;
    };
    /**
     * ustawienie $hasFocus na false
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$blur = function () {
        this.$hasFocus = false;
    };
    /**
     * pobranie wartości użytkownika
     *
     * @param {string} field nazwa pola
     * @param {*} [defaultvalue] wartośc domyślna gdy pole nie istnieje
     * @returns {*}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$getUserData = function (field, defaultvalue) {
        var value = this.$data[field];
        if (value === undefined) {
            if (defaultvalue === undefined) {
                this._options.Vue.set(this._internal.vmUserData, field, null);
            }
            else {
                this._options.Vue.set(this._internal.vmUserData, field, defaultvalue);
            }
            return this._internal.vmUserData[field];
        }
        return value;
    };
    /**
     * ustawienie danych użytkownika
     *
     * @param {string} field
     * @param {*} value
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$setUserData = function (field, value) {
        this._options.Vue.set(this.$data, field, value);
    };
    /**
     * niszczenie obiektu i zwalnianie zasobów
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$destroy = function () {
        if (this._internal.vm) {
            if (this._internal.vm.$destroy) {
                this._internal.vm.$destroy();
            }
        }
        // definitions
        var defs = this._internal.definitions;
        if (defs) {
            for (var key in defs) {
                defs[key].$destroy();
            }
        }
        delete this._options.disabledFields[this.$path];
    };
    /**
     * ustawianie $dirty na false
     *
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$reset = function () {
        this.$dirty = false;
        // this.internal.vm.error = null;
        // this.$error = null;
    };
    /**
     * lista elementów "dotkniętych", zawiera wszystkie elementy podrżedne
     *
     * @param {IWrappedProperty[]} result
     * @returns {IWrappedProperty[]}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$dirtyList = function (result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$dirty) {
            result.push(this);
        }
        return result;
    };
    /**
     * sprawdzanie ostrzeżeń
     *
     * @param {*} [value] wartość pola
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {string[]} [checkResult] tablica ostrzeżeń
     * @returns {string[]} wynikowa tablica ostrzeżeń
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$check = function (value, skipDirty, checkResult) {
        if (value === undefined) {
            value = this.$model;
        }
        if (this._internal.schema.warnings) {
            checkResult = checkResult || [];
            this.$checkResult = [];
            var funcs = (0, getValidations_1.getValidations)(this._internal.schema, this._internal.schema.warnings, true);
            for (var _i = 0, funcs_1 = funcs; _i < funcs_1.length; _i++) {
                var func = funcs_1[_i];
                var validation = func(value, this.$schema.warnings);
                if (validation) {
                    var message = (0, getRuleMessage_1.getWarningMessage)(this._internal, validation, value, this.$schema);
                    this.$checkResult.push({
                        validation: validation,
                        message: message,
                        expected: this.$schema.warnings[validation]
                    });
                    checkResult.push(message);
                    // return result;
                }
            }
            if (this._internal.vm && this._internal.vm.warningValidFunc) {
                // return this._internal.vm.validFunc;
                var message = (0, getRuleMessage_1.getWarningMessage)(this._internal, this._internal.vm.warningValidFunc, value, this.$schema);
                this.$checkResult.push({
                    validation: 'validFunc',
                    message: message,
                    expected: this._internal.vm.warningValidFunc
                });
                checkResult.push(message);
                // checkResult.push(getWarningMessage(this._internal, this._internal.vm.warningValidFunc, value, this.$schema));
            }
            return checkResult;
        }
        return (this.$checkResult = []);
    };
    /**
     * ostrzeżenie z tego pola i pól podrzędnych
     *
     * @param {boolean} [skipDirty] czy nie zaznaczać $dirty
     * @param {IWrappedProperty[]} [result]
     * @returns {IWrappedProperty[]}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$checkAll = function (skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$check(undefined, skipDirty).length) {
            result.push(this);
        }
        return result;
    };
    /**
     * walidacja elementu, zwraza komunikat błędu lub null
     *
     * @param {*} [value] wartość, jak nie podana to bierze z modelu
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @returns {(string | null)}  komunikat błędu lub null
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$validate = function (value, skipDirty) {
        // let stime = (new Date()).getTime();
        if (this.$disabled) {
            return null;
        }
        if (value === undefined) {
            value = this.$model;
        }
        var funcs = (0, getValidations_1.getValidations)(this._internal.schema, this._internal.schema, true);
        for (var _i = 0, funcs_2 = funcs; _i < funcs_2.length; _i++) {
            var func = funcs_2[_i];
            var validation = func(value, this.$schema);
            if (validation) {
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, validation, value, this.$schema);
                this.$validateResult = {
                    validation: validation,
                    message: message,
                    expected: this.$schema[validation]
                };
                return message;
                // return result;
            }
        }
        if (this._internal.schema.validFunc) {
            if (this._internal.vm && this._internal.vm.validFunc) {
                // return this._internal.vm.validFunc;
                var message = (0, getRuleMessage_1.getRuleMessage)(this._internal, this._internal.vm.validFunc, value, this.$schema);
                this.$validateResult = {
                    validation: 'validFunc',
                    message: message,
                    expected: this._internal.vm.validFunc
                };
                return message;
            }
        }
        return (this.$validateResult = null);
    };
    /**
     * waliduje element i wszystkie podrzędne
     *
     * @param {boolean} [skipDirty] czy ma nie zaznaczać pola jako dirty
     * @param {IWrappedProperty[]} [result] tymczasowa tablica lementów
     * @returns {IWrappedProperty[]} wynikowa tablica elementów które nie przeszły walidacji
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$validateAll = function (skipDirty, result) {
        if (result === undefined) {
            result = [];
        }
        if (this.$validate(undefined, skipDirty)) {
            result.push(this);
        }
        return result;
    };
    /**
     * ustawienie domyślnej wartości w polu
     * @returns {boolean} czy udało się ustawić nową wartość
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$setDefault = function () {
        var schema = this._internal.schema;
        var defValue = (0, defaultValue_1.default)(schema, true);
        this.$setData(defValue, undefined, true);
        if (schema.type === 'array') {
            // jeśli length było wyliczalne to wylicz
            if (this.$schema.length !== undefined && (typeof (schema.length) !== "number")) {
                this.$setLength(this.$schema.length);
            }
        }
        return true;
    };
    /**
     * ustawienie wartości w polu
     *
     * @param {*} value nowa wartość
     * @param {string} [path] ścieżka, przydatna gdy chcemy ustawić wartośc podrzędną
     * @param {boolean} [fixArraySize] czy wymuszac zmianę wielkości tablic
     * @returns {boolean} czy udało się ustawić nową wartość
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$setData = function (value, path, fixArraySize) {
        if (path) {
            return (0, setData_1.default)(this._internal.schema, this.$model, value, path, 0, this._internal.options.Vue, fixArraySize);
        }
        else {
            // this._options.Vue.set(this._internal.parent, this.$key, value);
            // lepiej tak bo następuje dopasowanie typu
            return (0, setData_1.setDataValue)(this.$schema, this._internal.parent, this.$key, value, this._options.Vue);
        }
    };
    /**
     * pobranie danych, omija pola `computed` i inne niezgodne ze schematem
     *
     * @param {boolean} [checkDataType] czy sprawdzać typy, jeśli true to nie zwraca pól z nieprawidłowymi wartościami
     * @returns {*} wyczyszczone dane modelu
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$getData = function (checkDataType) {
        return (0, clearData_1.default)(this._internal.schema, this.$model, checkDataType, this._options, this.$path);
    };
    /**
     * zdarzenie przed zmianą ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.beforePathChange = function () {
        var disabled = this.$schema.disabled;
        if (disabled) {
            delete this._options.disabledFields[this.$path];
        }
    };
    /**
     * zdarzenie po zmianie ścieżki
     *
     * @protected
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.afterPathChange = function () {
        var disabled = this.$schema.disabled;
        if (disabled) {
            this._options.disabledFields[this.$path] = true;
        }
    };
    /**
     * aktualizacja
     *
     * @param {*} newKey
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$changeKey = function (newKey) {
        this.beforePathChange();
        this._internal.key = newKey;
        this._internal.mparent = this._internal.parent[newKey];
        this.afterPathChange();
    };
    Object.defineProperty(WrappedPropertyBase.prototype, "$parent2", {
        /**
         * $parent.$parent
         *
         * @readonly
         * @type {(IWrappedProperty | null)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (!this.$parent) {
                return null;
            }
            return this.$parent.$parent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(WrappedPropertyBase.prototype, "$parent3", {
        /**
         * $parent.$parent.$parent
         *
         * @readonly
         * @type {(IWrappedProperty | null)}
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (!this.$parent2) {
                return null;
            }
            return this.$parent2.$parent;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * usuwanie bierzącego wiersza z tablicy
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$removeRow = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$removeRow(this.$key);
        }
        return false;
    };
    /**
     * przesuwanie bieżącego wiersza tablicy w górę
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$moveUp = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$moveUp(this.$key);
        }
        return false;
    };
    /**
     * przesuwanie bieżącego wiersza tablicy w dół
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$moveDown = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$moveDown(this.$key);
        }
        return false;
    };
    /**
     * czyszczenie bieżącego wiersza tablicy, nadawanie wartości domyślnych
     *
     * @param {number} [index]
     * @returns {boolean}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$clearRow = function (index) {
        if (this.$isArrayItem) {
            return this.$parent.$clearRow(this.$key);
        }
        return false;
    };
    /**
     * naprawianie formatu daty
     *
     * @returns {number}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.$fixDateFormat = function () {
        return 0;
    };
    /**
     * pobranie wartości z modelu
     *
     * @protected
     * @returns {*}
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.getValue = function () {
        return this.$model;
    };
    /**
     * ustawienie wartości na modelu
     *
     * @protected
     * @param {*} newValue
     * @memberof WrappedPropertyBase
     */
    WrappedPropertyBase.prototype.setValue = function (newValue) {
        if (!this.$schema.$disabled && !this.$dirty && this._internal.options.dirtyOnInput) {
            this.$dirty = true;
        }
        this.$model = newValue;
    };
    Object.defineProperty(WrappedPropertyBase.prototype, "$definitions", {
        /**
         * pobranie pól z definicji
         *
         * @protected
         * @memberof WrappedPropertyBase
         */
        get: function () {
            if (this._internal.definitions) {
                return this._internal.definitions;
            }
            var result = null;
            if (this._internal.schema.definitions) {
                result = {};
                var self_1 = this;
                var _loop_1 = function (key) {
                    var sobj = this_1._internal.schema.definitions[key];
                    var cache = null;
                    Object.defineProperty(result, key, {
                        get: function () {
                            if (cache) {
                                return cache;
                            }
                            else {
                                return (cache = (new WrappedPropertyCtor_1.default[sobj.type || "string"](self_1, {}, key, sobj, self_1._internal.options)));
                            }
                        }
                    });
                };
                var this_1 = this;
                for (var key in this._internal.schema.definitions) {
                    _loop_1(key);
                }
            }
            return (this._internal.definitions = result);
            // return ((this.$definitions as any).result = result);
        },
        enumerable: false,
        configurable: true
    });
    return WrappedPropertyBase;
}());
exports.default = WrappedPropertyBase;
//# sourceMappingURL=WrappedPropertyBase.js.map